import { apiCall } from 'app/dealer/actions';
import { logout } from 'app/dealer/login/actions';

import * as ActionTypes from './constants';
import { selectUserLoggedIn } from 'app/dealer/login/selectors';

/**
 * TODO:
 *
 * @note relevant topic: react router version update
 *
 * this function gets called whenever we enter a private (guarded) route `onEnter` api from react-router 3
 *
 * this is creating race conditions with other api calls, and results with strange behaviour (e.g multiple logouts, unnecessary api cals, lots of redirects)
 *
 * when another api call makes an unauthenticated request,
 * the user is logged out there, and then here again
 *
 * when we update react-router, we should think about how to handle fetching the authorities differently
 *
 * this will help us clean up a lot of conditional logic in our auth flow as well
 *
 * some ideas:
 *
 * - we could do polling
 * - we could conditionally render a private (guarded) route only AFTER this fetch is successful
 */
export const fetchAuthorities = () => {
  return (dispatch, getState) => {
    const url = '/uaa/user/authorities';
    const options = {
      method: 'GET',
    };
    if (!selectUserLoggedIn(getState())) {
      // there's nothing to do if the user is logged out
      return Promise.resolve({});
    }

    dispatch({
      type: ActionTypes.FETCH_AUTHORITIES_PENDING,
    });

    return dispatch(apiCall(url, options))
      .then(response => {
        const { groupAuthorities } = response;

        if (groupAuthorities.length === 0) {
          return dispatch(logout());
        }

        return dispatch({
          type: ActionTypes.FETCH_AUTHORITIES_SUCCESS,
          payload: { groupAuthorities },
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.FETCH_AUTHORITIES_FAILURE,
          error,
        });

        dispatch(logout());
      });
  };
};

export const resetAuthorities = () => {
  return {
    type: ActionTypes.RESET_AUTHORITIES,
  };
};
